export default __webpack_public_path__ + "sepa-bank-transfer.2f7fd8b.svg";